import React, { useState, createContext } from 'react';
import { Switch, Route, useHistory } from 'react-router-dom';

import { ExternalSignIn, SellerSignIn, SSRLoggedOut } from 'containers';
import { useAppContext } from 'utils/hooks';
import { IS_ALL_SSR } from 'dictionary';

/**
 * @type {React.Context<{
 *   authCache: Object|null,
 *   onAuthenticated: (authCache: Object, redirectPath?: string) => void
 * }>}
 */
export const AuthGuardContext = createContext({
  authCache: null,
  onAuthenticated: () => {}
});

export function AuthGuardProvider({ children = null }) {
  const { replace } = useHistory();

  const [authCache, setAuthCache] = useState(null);

  const { isSSREnv } = useAppContext();

  const onAuthenticated = (data, redirectPath = '/') => {
    setAuthCache(data);
    replace(redirectPath);
  };

  return (
    <AuthGuardContext.Provider value={{ authCache, onAuthenticated }}>
      <Switch>
        {/* SSR */}
        {isSSREnv && (
          <Route key="ssr-login" path="/seller-signin">
            <SellerSignIn />
          </Route>
        )}

        {/* IS_ALL_SSR: no login page exists, show error when logged out */}
        {IS_ALL_SSR && (
          <Route key="all-ssr-logged-out" path="/login">
            <SSRLoggedOut />
          </Route>
        )}

        {/* Warren */}
        {!isSSREnv && (
          <Route key="warren-login" path="/signin">
            <ExternalSignIn />
          </Route>
        )}

        <Route key="app-routes" path="/">
          {children}
        </Route>
      </Switch>
    </AuthGuardContext.Provider>
  );
}
